//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { channelTypes, getChannelCode } from '@motionelements/core/src/helpers/channelTypes';

export default {
  name: 'ProductPage',
  components: {
    ProductPageLayout: () => import('@motionelements/product2025/src/modules/ProductPageLayout.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    Breadcrumbs: () => import('@motionelements/core/src/components/ui/BaseBreadcrumbs.vue'),
    //
    BaseLayout: () => import('@/components/core/BaseLayout.vue'),
    NavBar: () => import('@/components/core/TheNavBar.vue'),
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      product: state => state.product.current,
    }),
    ...mapGetters({
      mediaType: 'product/mediaType',
    }),
    pageTitle() {
      if (this.product) {
        return _.get(this.product, 'html.title', this.productId);
      }
      return '';
    },
    pageDescription() {
      if (this.product) {
        return _.get(this.product, 'html.description', this.productId);
      }
      return '';
    },
    descriptionLength() {
      const descriptions = _.get(this.product, 'descriptions');

      if (Array.isArray(descriptions) && descriptions.length) {
        let length = 0;

        descriptions.forEach((obj) => {
          const html = _.get(obj, 'html');
          if (html && html.length > length) {
            length = obj.html.length;
          }
        });

        return length;
      }

      return _.get(this.product, 'description', '').length;
    },
    meta() {
      return [
        {
          hid: 'description',
          name: 'description',
          content: this.pageDescription,
        },
        {
          hid: 'robots',
          name: 'robots',
          content: this.descriptionLength > 400 ? 'index, nofollow' : 'none',
        },
      ];
    },
    primaryCategory() {
      if (this.product?.categories?.length) {
        let category;
        if (this.mediaType === 'music') {
          // get genre for music
          category = this.product.categories.find(x => x.type === 'genre');
          if (category) {
            return category;
          }
        }
        // return first category
        return this.product.categories[0];
      }
      return null;
    },
    getChannelCode() {
      return getChannelCode(this.mediaType.replace('-', '_'));
    },
    breadcrumbs() {
      // generate breadcrumbs data
      const list = [];
      if (this.product) {
        const channel = this.getChannelCode;
        list.push({
          name: channel === 'ae' ? this.$t(`header.${channel}`) : this.$term('mediaType', channel).short().text(),
          // nameSeo overwrites name for display in jsonLd
          nameSeo: this.$term('mediaType', channel).seo().text(),
          link: _.get(this.getChannelTypeById(channel), 'link'),
        });
        /*
      // show artist is search is artist
      if (this.$route.path.match('artists') && this.artistUsername) {
        list.push({
          name: this.artistUsername,
          link: this.$link(`/${routeConst.ARTISTS}/${this.artistUsername.toLowerCase()}`).url(),
        });
      }
      */
        if (this.primaryCategory && _.get(this.primaryCategory, 'name')) {
          list.push({
            name: this.primaryCategory.name,
            link: _.get(this.primaryCategory, 'html.url'),
          });
        }
        // finally show this product
        list.push({
          active: true,
          name: this.product.name,
          nameSeo: this.product ? `${this.product.name} ${this.$term('mediaType', this.mediaType).seo().text()}` : null,
          link: _.get(this.product, 'html.url'),
        });
      }
      return list;
    },
  },
  methods: {
    getChannelTypeById(channelTypeId) {
      return channelTypes.find(({ id }) => id === getChannelCode(channelTypeId));
    },
  },
};
